import SelectClient from "../MoneyTransfers/Steps/SelectClient";
import * as React from "react";
import {ChangeEvent, useEffect, useMemo, useState} from "react";
import {holderAPI} from "../../../services/holderAPI.service";
import {useGlobalContext} from "../../../services/context.service";
import {IHolders} from "../../../services/response.interface";
import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";
import {FormControlLabel, Grid, Radio, RadioGroup} from "@mui/material";
import {fnLocalizeFilter} from "../../../services/localize.service";
import InputFilled from "../../UI/Input/InputFilled";
import Button from "@mui/material/Button";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {genSocarPDF} from "./Template/Socar/PDFSocar";
import {TDocumentDefinitions} from "pdfmake/interfaces";
import {Document, Page, pdfjs} from "react-pdf";
//import {Document, Page, pdfjs} from 'react-pdf/dist/esm/entry.webpack';
import {getWorkBook, savePDFFile} from "./commonMethods";
import {IBillingDoc, TTypeBill} from "./Template/interface.billing";
import {getConfigFromFile} from "../../../utils/methods";
import {Workbook} from "exceljs";
import moment from "moment";
import {IConfig} from "../../../utils/interface";
import {getSocarXLSXFile} from "./Template/Socar/XLSXSocar";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;



const ContainerBilling = styled(Box)(() => ({
    padding: "1rem", maxWidth: "500px"
}));


export default function Billing() {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const {locale} = useGlobalContext();
    /* Получаем список клиентов доступных пользователю */
    const {data: dataHolder = {holders: []}} = holderAPI.useFetchAllClientsQuery({locale});

    const [holder, setHolder] = useState<IHolders>();

    useEffect(() => {
        dataHolder.holders.length > 0 && setHolder(dataHolder.holders[0]);
    }, [dataHolder.holders]);

    const handleChangeClient = (holderId: number) => {
        const holder = dataHolder.holders.find(holder => holder.holderId === holderId);
        setHolder(holder);
    };
    /**
     * Тип счета
     */
    const [selectedType, setSelectedType] = React.useState<TTypeBill>('fuel');
    const handleChangeBillType = (e: ChangeEvent<HTMLInputElement>) => {
        setSelectedType(e.target.value as TTypeBill);
    };

    /**
     * Сумма счета
     */
    const [sum, setSum] = useState<number>(0);
    const handleChangeSum = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSum(+e.target.value);
    };

    const generatePreviewPDF = (dd: TDocumentDefinitions): Promise<string> => {
        return new Promise(resolve => {
            pdfMake.createPdf(dd).getDataUrl((data) => {
                resolve(data)
            });
        })
    };

    const generateBufferPDF = async (dd: TDocumentDefinitions): Promise<Buffer> => {
        return new Promise(resolve => {
            pdfMake.createPdf(dd).getBuffer((buffer) => {
                resolve(buffer)
            });
        })
    };

    /**
     * Получаем строки из xls шаблона Постаальник
     */
    const getSupplier = (wb: Workbook) => {
        const ws = wb.worksheets[0];
        const supplier = [];
        let strIdx = 4;
        while (ws.getCell(strIdx, 3).value !== null) {
            supplier.push(ws.getCell(strIdx, 3).value as string);
            strIdx++;
        }
        return supplier;
    };

    const typeBillVar = useMemo(async () => {
        const {config: {bills}}: IConfig = await getConfigFromFile();
        let tax, shortTypeGoods, typeGoods;
        if (selectedType === "fuel") {
            tax = bills.billTax.fuel;
            typeGoods = 'Оплата за нафтопродукти';
            shortTypeGoods = 'Н/П'
        } else {
            tax = bills.billTax.goods;
            typeGoods = 'Оплата за товари та послуги';
            shortTypeGoods = 'товар'
        }
        return {tax, shortTypeGoods, typeGoods}
    }, [selectedType]);

    const [numBill, setNumBill] = useState<string>('');
    const [previewPDF, setPreviewPDF] = useState<string>('');
    /**
     * Отображаем превью пдф
     */
    const handleGetPreviewPDF = async () => {
        const {config: {bills}}: IConfig = await getConfigFromFile();
        const wb = await getWorkBook();

        const supplier = getSupplier(wb);
        /* Получаем общие зависящие от типа данные */
        const {tax, shortTypeGoods, typeGoods} = await typeBillVar;
        const numBill = `${bills.prefix}-${moment().format('YYYYMMDDHHmmss')}`;
        setNumBill(numBill);
        const dd = await genSocarPDF({numBill, supplier, holder, tax, typeGoods, shortTypeGoods, sum} as IBillingDoc);
        const filePDF = await generatePreviewPDF(dd);

        setPreviewPDF(filePDF as string);
    };

    const handleGetFilePDF = async () => {
        const wb = await getWorkBook();
        const supplier = getSupplier(wb);
        /* Получаем общие зависящие от типа данные */
        const {tax, shortTypeGoods, typeGoods} = await typeBillVar;
        const dd = await genSocarPDF({numBill, supplier, holder, tax, typeGoods, shortTypeGoods, sum} as IBillingDoc);
        const bufferPDF = await generateBufferPDF(dd);

        bufferPDF && await savePDFFile(bufferPDF, numBill);
    };

    const handleGetFileXLS = async () => {
        const wb = await getWorkBook();
        const supplier = getSupplier(wb);
        /* Получаем общие зависящие от типа данные */
        const {tax, shortTypeGoods, typeGoods} = await typeBillVar;
        await getSocarXLSXFile({numBill,supplier, holder, tax, typeGoods, shortTypeGoods, sum} as IBillingDoc);
    };

    return <Grid sx={{display: 'flex', flexWrap: 'wrap'}}>
        <Grid>
            <ContainerBilling>
                <SelectClient
                    holders={dataHolder.holders}
                    selectHolderId={holder?.holderId || -1}
                    onSelectClient={handleChangeClient}
                />
                <RadioGroup onChange={handleChangeBillType} style={{margin: "1rem 0 0 1rem"}}>
                    <FormControlLabel name={'radio-button-type-bill'} value={'fuel'}
                                      control={<Radio checked={selectedType === 'fuel'}/>}
                                      label={fnLocalizeFilter(locale, "_lang.module.billing.typeFuel")}/>
                    <FormControlLabel name={'radio-button-type-bill'} value={'goods'}
                                      control={<Radio checked={selectedType === 'goods'}/>}
                                      label={fnLocalizeFilter(locale, "_lang.module.billing.typeGoods")}/>
                </RadioGroup>
                <InputFilled label={fnLocalizeFilter(locale, '_lang.module.common.title.titleSum')}
                             onChange={handleChangeSum} value={sum}
                             type={'number'} sx={{margin: "2rem 0 1rem 0 !important"}}/>
                <Button
                    variant={'contained'}
                    sx={{width: "100%"}}
                    onClick={handleGetPreviewPDF}
                    disabled={sum === 0}
                >{fnLocalizeFilter(locale, '_lang.module.billing.titleBtnCreateInvoice')}</Button>
                {previewPDF !== '' && <>
                    <Box display={'flex'} justifyContent={'space-between'} marginTop={'1rem'}>
                        <Button
                            variant={'contained'}

                            onClick={handleGetFileXLS}
                        >{fnLocalizeFilter(locale, '_lang.module.billing.titleBtnSaveXLSX')}</Button>
                        <Button
                            variant={'contained'}

                            onClick={handleGetFilePDF}
                        >{fnLocalizeFilter(locale, '_lang.module.billing.titleBtnSavePDF')}</Button>
                    </Box>
                </>}


            </ContainerBilling>
        </Grid>
        <Grid overflow={'auto'}>
            {previewPDF !== '' && <Box style={{border: '1px solid #eee'}}>
                <Document file={previewPDF} loading={fnLocalizeFilter(locale, '_lang.module.billing.titleLoadingFile')} >
                    <Page pageNumber={1} width={700}/>
                </Document>
            </Box>}
        </Grid>
    </Grid>

}
